import React, { forwardRef } from 'react';

import { Box, CircularProgress } from '@mui/material';
import { StyledPKDFilledButton } from './styles';


export const PKDFilledButton = forwardRef(({ sx, ...props }, ref) => {
  return (
    <StyledPKDFilledButton
      data-testid='filled-button' ref={ref} sx={sx} {...props} >
      <Box
        sx={{ display: 'flex', alignItems: 'center' }}>
        {props.children}{' '}
        {props.isLoading && (
          <CircularProgress
            data-testid='loading-spinner' sx={{ marginLeft: 1 }} color='inherit' size={20}
          />
        )}
      </Box>
    </StyledPKDFilledButton>
  );
});
